import { matchPath } from 'react-router-dom';

export const isRouteIncluded =
  (routesToMatch, options = {}) =>
  (route) => {
    options.exact ??= false;
    const matches = routesToMatch.map((path) =>
      matchPath(route, { path, exact: options.exact })
    );
    return matches.some(Boolean);
  };

export const isRouteMatching = (currentPath) => (path) => {
  const match = matchPath(currentPath, { path });
  return match;
};
